var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _g4, _path12, _path13, _path14, _g5, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationPushPython = function SvgIllustrationPushPython(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 160,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-push-python_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__b)",
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#634F69",
    fillOpacity: 0.45,
    d: "M199.21 142 176 134.195 198.79 126l23.21 7.805z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__c)",
    d: "M199.21 142 176 134.195 198.79 126l23.21 7.805z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__d)",
    d: "M178 46h42v88h-42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__e)",
    fillRule: "evenodd",
    d: "M199 90c.276 0 .5.182.5.406v42.188c0 .224-.224.406-.5.406s-.5-.182-.5-.406V90.406c0-.224.224-.406.5-.406",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    d: "M201 80a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__g)",
    opacity: 0.6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#634F69",
    fillOpacity: 0.45,
    d: "M101.21 142 78 134.195 100.79 126l23.21 7.805z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__h)",
    d: "M101.21 142 78 134.195 100.79 126l23.21 7.805z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    d: "M103 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__j)",
    fillRule: "evenodd",
    d: "M101 97.5a.5.5 0 0 1 .5.5v35a.5.5 0 0 1-1 0V98a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__k)",
    d: "M80 83h42v51H80z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__l)",
    opacity: 0.6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#634F69",
    fillOpacity: 0.45,
    d: "M150.21 159 127 151.195 149.79 143l23.21 7.805z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__m)",
    d: "M150.21 159 127 151.195 149.79 143l23.21 7.805z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    d: "M152 96a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__o)",
    fillRule: "evenodd",
    d: "M150 114.5a.5.5 0 0 1 .5.5v35a.5.5 0 0 1-1 0v-35a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__p)",
    d: "M129 100h41v51h-41z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__q)",
    opacity: 0.6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#634F69",
    fillOpacity: 0.45,
    d: "M37.338 159 3 147l33.662-13L71 147z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__r)",
    d: "M37.338 159 3 147l33.662-13L71 147z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__s)",
    fillRule: "evenodd",
    d: "M37 95.5c.276 0 .5.126.5.282v47.436c0 .156-.224.282-.5.282s-.5-.126-.5-.282V95.782c0-.156.224-.282.5-.282",
    clipRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    d: "M39 84a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__u)",
    d: "M5 86h64v61H5z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__v)",
    opacity: 0.6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#634F69",
    fillOpacity: 0.45,
    d: "M263.338 159 229 147l33.662-13L297 147z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__w)",
    d: "M263.338 159 229 147l33.662-13L297 147z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__x)",
    fillRule: "evenodd",
    d: "M263 76a.5.5 0 0 1 .5.5v70a.5.5 0 0 1-1 0v-70a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-push-python_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    d: "M265 27a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-push-python_svg__z)",
    d: "M231 43h64v104h-64z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__c",
    x1: 176.525,
    x2: 217.575,
    y1: 133.619,
    y2: 133.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#AD8EB6",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8EB6",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__d",
    x1: 199,
    x2: 199,
    y1: 46,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__e",
    x1: 199.766,
    x2: 199.488,
    y1: 90.599,
    y2: 133.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__h",
    x1: 78.525,
    x2: 119.575,
    y1: 133.619,
    y2: 133.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#AD8EB6",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8EB6",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__j",
    x1: 101.766,
    x2: 101.574,
    y1: 98.161,
    y2: 134.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__k",
    x1: 101,
    x2: 101,
    y1: 83,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__m",
    x1: 127.525,
    x2: 168.575,
    y1: 150.619,
    y2: 150.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#AD8EB6",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8EB6",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__o",
    x1: 150.766,
    x2: 150.574,
    y1: 115.161,
    y2: 151.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__p",
    x1: 149.5,
    x2: 149.5,
    y1: 100,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__r",
    x1: 0.845,
    x2: 66.881,
    y1: 145.905,
    y2: 145.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#F5C0C0",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__s",
    x1: 37.766,
    x2: 37.414,
    y1: 96,
    y2: 144.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__u",
    x1: 37,
    x2: 37,
    y1: 86,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__w",
    x1: 226.845,
    x2: 292.881,
    y1: 145.905,
    y2: 145.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#F5C0C0",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__x",
    x1: 263.766,
    x2: 263,
    y1: 76.821,
    y2: 148.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-push-python_svg__z",
    x1: 263,
    x2: 263,
    y1: 43,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__b",
    width: 78,
    height: 48,
    x: 160,
    y: 118,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_21039",
    result: "effect2_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_21039",
    result: "effect3_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__f",
    width: 8,
    height: 8,
    x: 195,
    y: 76,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.752941 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__g",
    width: 78,
    height: 48,
    x: 62,
    y: 118,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_21039",
    result: "effect2_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_21039",
    result: "effect3_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__i",
    width: 8,
    height: 8,
    x: 97,
    y: 10,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.752941 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__l",
    width: 78,
    height: 48,
    x: 111,
    y: 135,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_21039",
    result: "effect2_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_21039",
    result: "effect3_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__n",
    width: 8,
    height: 8,
    x: 146,
    y: 92,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.752941 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__q",
    width: 100,
    height: 57,
    x: -13,
    y: 126,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_21039",
    result: "effect2_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_21039",
    result: "effect3_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__t",
    width: 8,
    height: 8,
    x: 33,
    y: 80,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.752941 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__v",
    width: 100,
    height: 57,
    x: 213,
    y: 126,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_21039",
    result: "effect2_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_21039",
    result: "effect3_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-push-python_svg__y",
    width: 8,
    height: 8,
    x: 259,
    y: 23,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.752941 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_21039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_893_21039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-push-python_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h300v160H0z"
  })))));
};
export { SvgIllustrationPushPython as ReactComponent };
export default __webpack_public_path__ + "static/illustration-push-python.94bff872.svg";